import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";

export const NavbarWrapper = styled(Navbar)`
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 4px 16px #a7afb71a;
`;
